import { AxiosResponse } from 'axios'
import { Article } from 'types/article'
import { api } from '@services/api'

interface indexParams {
  per?: number
  page?: number
  editorial_slug?: string
  more_reads?: boolean
}

const index = async (
  query?: indexParams
): Promise<AxiosResponse<{ articles: Article[] }>> => {
  const params = new URLSearchParams()

  if (query) {
    Object.entries(query).map(([key, value]) => params.append(key, value))
  }
  return api.get('/articles', { params })
}

const show = async (slug: string): Promise<AxiosResponse<Article>> =>
  api.get(`/articles/${slug}`)

// Novo método para destaques dos especialistas
const specialistsHighlights = async (): Promise<
  AxiosResponse<{ articles: Article[] }>
> => api.get('/articles/specialists_highlights')

// Novo método para últimos artigos publicados
const latest = async (
  limit: number = 20
): Promise<AxiosResponse<{ articles: Article[] }>> => {
  const params = new URLSearchParams()
  params.append('per', limit.toString())
  params.append('page', '1')
  return api.get('/articles', { params })
}

export const ArticlesApi = {
  index,
  show,
  specialistsHighlights,
  latest
}
